'use strict';

/*global app*/
/*global services*/
/*global createObjectCallBack*/
/*global nl2br*/
/*global normalizeInput*/

function ConfirmService() {
  this.confirmModal = null;

  this.init();
}

ConfirmService.prototype = $.extend({}, {
  constructor: 'ConfirmService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  clb: function clb(callback, ret) {
    var _this = this;

    _this.confirmModal.close(function () {
      if (callback) {
        callback(ret);
      }
    });

    return _this;
  },

  confirmClb: function confirmClb(callback) {
    var _this = this;

    _this.clb(callback, true);

    return _this;
  },

  rejectClb: function rejectClb(callback) {
    var _this = this;

    _this.clb(callback, false);

    return _this;
  },

  cancelClb: function cancelClb(callback) {
    var _this = this;

    _this.clb(callback, null);

    return _this;
  },

  confirm: function confirm(data, callback) {
    var _this = this;

    data = normalizeInput(data);

    var content = data.content;

    if (data.asHtml) {
      content = '<p class="text-center">' + nl2br(content) + '</p>';
    }

    _this.confirmModal.open({
      title: data.title,
      confirmCallBack: createObjectCallBack(_this, 'confirmClb', callback),
      confirmBtnTitle: app.t('yes'),
      rejectCallBack: createObjectCallBack(_this, 'rejectClb', callback),
      rejectBtnTitle: app.t('no'),
      buttonsSize: 'lg',
      width: 'md',
      content: content
    });

    return _this;
  },

  confirmCancel: function confirmCancel(data, callback) {
    var _this = this;

    data = normalizeInput(data);

    var content = data.content;

    if (data.asHtml) {
      content = '<p class="text-center">' + nl2br(content) + '</p>';
    }

    _this.confirmModal.open({
      title: data.title,
      confirmCallBack: createObjectCallBack(_this, 'confirmClb', callback),
      confirmBtnTitle: app.t('yes'),
      rejectCallBack: createObjectCallBack(_this, 'rejectClb', callback),
      rejectBtnTitle: app.t('no'),
      cancelCallBack: createObjectCallBack(_this, 'cancelClb', callback),
      cancelBtnTitle: app.t('cancel'),
      buttonsSize: 'lg',
      width: 'md',
      content: content,
      viewCancelBtn: true
    });

    return _this;
  },

  confirmHtml: function confirmHtml(data, callback) {
    var _this = this;

    data = normalizeInput(data);

    data.asHtml = true;

    _this.confirm(data, callback);

    return _this;
  },

  confirmCancelHtml: function confirmCancelHtml(data, callback) {
    var _this = this;

    data = normalizeInput(data);

    data.asHtml = true;

    _this.confirmCancel(data, callback);

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.confirmModal = services.get('confirm');

    _this.registerCallbacks();

    return _this;
  }
});
